import React, { Component } from "react";
import ButtonIcon from "../../button";
import { TYPE_FUNCTION } from "../../../constants/external-constants";

export default class CustomDropdownButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggle: false,
            openCategory: null,
        };
        this.buttonRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("click", this.handleDocumentClick);
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleDocumentClick);
    }

    handleDocumentClick = (event) => {
        if (this.buttonRef.current && !this.buttonRef.current.contains(event.target)) {
            this.setState({ toggle: false, openCategory: null });
        }
    };

    handleClickList = (id) => {
        if (typeof this.props.onSelect === TYPE_FUNCTION) {
            this.props.onSelect(id);
        }
        this.setState({ toggle: false, openCategory: null });
    };

    handleCategoryClick = (category) => {
        this.setState((prevState) => ({
            openCategory: prevState.openCategory === category ? null : category
        }));
    };

    render() {
        const { customClassName, extractListLabel, options, multipleList, isDisable } = this.props;
        const { toggle, openCategory } = this.state;

        return (
            <div className="download_template__container">
                <div className={`custom-dropdown-button-container ${customClassName}`} ref={this.buttonRef}>
                    <ButtonIcon
                        onClick={() => {
                            if (!isDisable) {
                                this.setState((prev) => ({ toggle: !prev.toggle, openCategory: null }));
                            }
                        }}
                        iconLeft="cloud-arrow-down"
                        iconSize="17px"
                        customClassName="header-filter-button header-option-list"
                        labelName={extractListLabel}
                        isDisable={isDisable} 
                    />
                    {toggle && !isDisable && ( 
                        <div className="custom-dropdown-list end-0">
                            {
                                multipleList ? (
                                    <ul className="list-container">
                                        {options.map((group, index) => (
                                            <li key={index} className="dropdown-category" onClick={() => this.handleCategoryClick(group.category)}>
                                                <div
                                                    className="category-title"
                                                >
                                                    {group.category}
                                                </div>
                                                {openCategory === group.category && (
                                                    <ul className="subcategory-list">
                                                        <span className="sub_title">Templates</span>
                                                        {group.templates.map((template, i) => (
                                                            <li
                                                                key={i}
                                                                onClick={() => this.handleClickList(template.id)}
                                                                className="subcategory-item"
                                                            >
                                                                {template.label}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <ul>
                                        {options.map((list, index) => (
                                            <li key={index} onClick={() => this.handleClickList(list.id)}>
                                                {list.label}
                                            </li>
                                        ))}
                                    </ul>
                                )
                            }
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
